var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-vue-select',{attrs:{"label-field":"name","value-field":"name","model":_vm.schoolModel.schoolName,"values":_vm.options,"ajax":!_vm.isSecretary,"taggable":!_vm.isSecretary},on:{"input":_vm.updateSchoolData,"search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }